// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"TaskCreateEditForm_MainContainer__JMwaB","Heading":"TaskCreateEditForm_Heading__2Ba3c","ColButton":"TaskCreateEditForm_ColButton__23MEE"};